




























































import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';

import ExternalLinkIcon from '@/components/icons/ExternalLinkV2.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import CheckIcon from '@/components/icons/Check.vue';
import CircleArrow from '@/componentsV2/atoms/CircleArrow/CircleArrow.vue';

// Provider logo components
import CloverLogo from '@/components/icons/providers/Clover.vue';
import SquareLogo from '@/components/icons/providers/Square.vue';
import WixLogo from '@/components/icons/providers/Wix.vue';
import WooCommerceLogo from '@/components/icons/providers/WooCommerce.vue';
import ShopifyLogo from '@/components/icons/providers/Shopify.vue';
import BigCommerceLogo from '@/components/icons/providers/BigCommerce.vue';
import OtherIcon from '@/components/icons/providers/Other.vue';
import ToastLogo from '@/components/icons/providers/Toast.vue';

type ProviderData = {
  imagePath?: string;
  component?: string;
};

export type CheckboxProviderVariant = 'sm' | 'md';

@Component<CheckboxProvider>({
  components: {
    ExternalLinkIcon,
    Input,
    CheckIcon,
    CircleArrow,

    CloverLogo,
    SquareLogo,
    ToastLogo,
    WixLogo,
    WooCommerceLogo,
    ShopifyLogo,
    BigCommerceLogo,
    OtherIcon
  }
})
export default class CheckboxProvider extends Vue {
  @Model('input', { type: String, default: '' }) value!: string;

  @Prop(String) name!: string;
  @Prop({ default: '' }) activeProvider?: string;
  @Prop({ default: false }) requiredLink?: string;
  @Prop({ default: false }) hideExternalIcon?: boolean;
  @Prop(String) label!: string;
  @Prop({ default: false }) hasError?: boolean;
  @Prop({ default: true }) showInput?: boolean;
  @Prop({ default: '' }) helpText?: string;
  @Prop({ default: 'sm' }) variant?: CheckboxProviderVariant;
  @Prop(String) inputLabel?: string;
  @Prop(String) inputPlaceholder?: string;

  get providerData() {
    const data: Record<string, ProviderData> = {
      bigcommerce: {
        component: 'BigCommerceLogo'
      },
      wix: {
        component: 'WixLogo'
      },
      shopify: {
        component: 'ShopifyLogo'
      },
      woocommerce: {
        component: 'WooCommerceLogo'
      },
      square: {
        component: 'SquareLogo'
      },
      clover: {
        component: 'CloverLogo'
      },
      without: {
        component: 'OtherIcon'
      },
      other: {
        component: 'OtherIcon'
      }
    };

    return data[this.name] || {};
  }

  get isMarcked() {
    return this.activeProvider === this.name;
  }

  @Watch('isMarcked')
  onIsMarckedChange(newValue: boolean) {
    if (!newValue && this.requiredLink) {
      this.$emit('input', '');
    }
  }

  toggle() {
    this.$emit('toggle', this.name);
  }
}
